module.exports = __webpack_public_path__ + "img/pie-chart-disabled.aeeacac4.svg";